import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PasswordService } from '~/services/identity/password';
import { EnvironmentLoaderService } from '~/services/BackEndURL/environment-loader.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.html',
    styleUrls: ['./forgot-password.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {
  _email = new FormControl('', [Validators.required, Validators.email]);
  _confirmationStep = false;
  _emailSentStep = false;
  submitted = false;
  loading = false;
  error: string;
  currentYear: number = new Date().getFullYear();

  get footerUrls() {
    const config = EnvironmentLoaderService.envConfig;
    return {
      releaseNoteUrl: config?.releaseNoteUrl || 'https://asapsystems.com/inventory-asset-tracking-release-notes/',
      contactUsUrl: config?.contactUsUrl || 'https://barcloud.com/company/contact-us/',
      companyUrl: config?.companyUrl || 'https://asapsystems.com/company/barcloud-about-us/',
      returnPolicyUrl: config?.returnPolicyUrl || 'https://barcloud.com/return-policy/',
      privacyPolicyUrl: config?.privacyPolicyUrl || 'https://barcloud.com/privacy-policy/',
      termsOfServiceUrl: config?.termsOfServiceUrl || config?.termsAndConditionsUrl || 'https://barcloud.com/terms-of-service/',
      termsAndConditionsUrl: config?.termsAndConditionsUrl || config?.termsOfServiceUrl || 'https://barcloud.com/terms-of-service/',
    };
  }

  constructor(
    private _passwordService: PasswordService,
    private router: Router
  ) { }

  ngOnInit() { }

  onNext() {
    this.submitted = true;
    this.error = null;
    if (this._email.invalid) {
      return;
    }
    this._confirmationStep = true;
  }

  onBackToEdit() {
    this._confirmationStep = false;
    this.submitted = false;
    this.error = null;
  }

  onSubmit() {
    if (this._email.invalid) {
      return;
    }
    this.loading = true;
    this.error = null;

    const model = {
      email: this._email.value,
    };

    this._passwordService.forgot(model).subscribe(
      () => {
        this.loading = false;
        this._confirmationStep = false;
        this._emailSentStep = true;
      },
      (error: any) => {
        this.loading = false;
        const msg = typeof error?.error === 'string'
          ? error.error
          : error?.error?.message || error?.error?.data || error?.message;
        this.error = msg || 'Invalid email or failed to send reset email.';
      }
    );
  }

  onReturn() {
    this.router.navigate(['/login']);
  }
}
